import styled from 'styled-components';
import 'animate.css';

/**
 * This component shows correct and wrong answers of user in the current level
 * until the question that has been answered. The component is located on the bottom of games' page
 *
 */
const GameStatusIndicator = ({ totalMaterials, doneMaterials, prevTotalMaterials }) => {
  const Container = styled.div`
    padding: 10px 20px;
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  `;

  const Indicator = styled.div`
    width: ${window.innerWidth / (totalMaterials.length * 1.5)}px;
    height: 5px;
    border-radius: 20%;
    background-color: #efefef;
    background-size: contain;
    background-position: center;
    border: 0.7px solid black;

    &.correct {
      background-color: green;
    }

    &.wrong {
      background-color: red;
    }
  `;

  return (
    <Container>
      {
        totalMaterials
          .map(({ oidx }) => ((
            <Indicator
              className={
                doneMaterials[oidx + prevTotalMaterials]
                  ? `${doneMaterials[oidx + prevTotalMaterials]
                    .split('-')[0]} animate__animated animate__bounce` : null
              }
            />
          )
          ))
      }
    </Container>
  );
};

export default GameStatusIndicator;
